<template>
  <div class="well" :class="{ collapsed: isCollapsed }">
    <div class="filters">
      <slot name="filters"></slot>
      <template v-if="showAdvanced">
        <slot name="advanced-filters"></slot>
      </template>
    </div>
    <div class="actions">
      <slot name="actions">
        <div class="actions-left">
          <slot name="actions-left">
            <VButton
              v-if="showAdvancedOption"
              class="ghost primary"
              @click="() => (showAdvanced = !showAdvanced)"
            >
              {{ advancedLabel }}
            </VButton>
          </slot>
        </div>
        <div class="actions-right">
          <slot name="actions-right">
            <VButton
              v-if="showClear"
              class="ghost destructive"
              @click="emitClear"
            >
              Clear All
            </VButton>
            <VButton class="primary" v-if="showSubmit" @click="emitSubmit">
              Submit
            </VButton>
          </slot>
        </div>
      </slot>
    </div>
  </div>
</template>
<script>
import VButton from "./VButton.vue";

export default {
  name: "VFilterGroup",
  components: { VButton },
  props: {
    showSubmit: {
      type: Boolean,
      default: true,
    },
    showClear: {
      type: Boolean,
      default: true,
    },
    showAdvancedOption: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isCollapsed: false,
      showAdvanced: false,
    };
  },
  computed: {
    advancedLabel() {
      return this.showAdvanced
        ? "Hide Advanced Filters"
        : "Show Advanced Filters";
    },
  },
  methods: {
    toggle() {
      this.isCollapsed = !this.isCollapsed;
    },
    emitSubmit() {
      this.$emit("submit-filters");
    },
    emitClear() {
      this.$emit("clear-filters");
    },
  },
};
</script>

<style scoped>
div.filters >>> label {
  line-height: 1.333;
}

div.well {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 2.5rem;
  /* Gray 75 */
  background: #fdfdfd;

  /* Gray 400 */
  border: 1px solid #b1b1b1;

  /* Inner Shadow - Gray */
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 1rem;
  min-width: 22.9375rem;
}

div.filters {
  --temp-column-width: 12.5rem;
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(
    auto-fill,
    [col] var(--temp-column-width, 20rem)
  );
  grid-template-rows: repeat(auto-fill, [row] auto);
}

div.filters > div#con-ids-fil-label {
  grid-column: 1 / -1;
}

div.actions {
  display: flex;
  justify-content: space-between;
}

div.actions-right {
  display: flex;
  gap: 1rem;
}

div.hidden {
  display: hidden;
}

/* Incident Reports Listing specific which doesn't use buttons */
div.well.incident-report-listing-filters {
  gap: 0rem;
}
</style>
